
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[category]",
      function () {
        return require("private-next-pages/services/[category]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[category]"])
      });
    }
  